import Reset_pass_v1 from './reset_pass';

export default Reset_pass_v1;

export {
    Reset_pass_v1
}